// Lumielle — scripts propios. Un init por componente, llamados desde DOMContentLoaded.

function initReveal() {
  const els = document.querySelectorAll('.lm-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('lm-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('lm-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.16, rootMargin: '0px 0px -6% 0px' }
  );
  els.forEach((el, i) => {
    const group = el.closest('[data-lm-stagger]');
    if (group) {
      const siblings = Array.from(group.querySelectorAll('.lm-reveal'));
      const idx = siblings.indexOf(el);
      el.style.setProperty('--lm-delay', (idx * 0.1) + 's');
    }
    io.observe(el);
  });
}

function initParallax() {
  const els = document.querySelectorAll('.lm-parallax');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.innerWidth < 750) return;
  let ticking = false;
  function update() {
    const vh = window.innerHeight;
    els.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      const progress = (rect.top / vh);
      el.style.transform = 'translateY(' + (progress * 26) + 'px) scale(1.08)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', () => {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();
}

document.addEventListener('DOMContentLoaded', () => {
  initReveal();
  initParallax();
});
